import { render, staticRenderFns } from "./UserInfoMenu.vue?vue&type=template&id=465a336a&scoped=true"
import script from "./UserInfoMenu.vue?vue&type=script&lang=js"
export * from "./UserInfoMenu.vue?vue&type=script&lang=js"
import style0 from "./UserInfoMenu.vue?vue&type=style&index=0&id=465a336a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a336a",
  null
  
)

export default component.exports